import { motion } from "framer-motion";

const LOGO_URL = "/logo.png";

const socialLinks = [
  {
    name: "Instagram",
    url: "https://www.instagram.com/vickiannmysteryscoop?igsh=MXJtd25pemRsZ21yMg%3D%3D&utm_source=qr",
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
      </svg>
    ),
  },
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@vicki.anns.luxuri",
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
        <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.46V13.2a8.16 8.16 0 005.58 2.2v-3.44a4.85 4.85 0 01-2-.48 4.82 4.82 0 01-1.77-1.49V6.69h3.77z" />
      </svg>
    ),
  },
  {
    name: "YouTube",
    url: "https://youtube.com/@vickiannmysteryscoop",
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/share/1DgXWJjMkn/",
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    ),
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="border-t border-[#D4AF37]/10 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="flex flex-col items-center text-center">
          {/* Logo */}
          <motion.img
            src={LOGO_URL}
            alt="Vicki Ann's Luxurious Gifts"
            className="w-48 mb-8"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          />

          {/* Tagline */}
          <p className="font-great-vibes text-[#D4AF37]/60 text-xl mb-10">
            Where Every Golden Egg Reveals a Designer Dream
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-6 mb-10">
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-link-${social.name.toLowerCase()}`}
                className="w-12 h-12 rounded-full border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37]/60 hover:text-[#D4AF37] hover:border-[#D4AF37] hover:shadow-[0_0_15px_rgba(212,175,55,0.2)] transition-all duration-300"
                title={social.name}
              >
                {social.icon}
              </a>
            ))}
          </div>

          {/* Divider */}
          <div className="gold-line w-48 mb-8" />

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-8 mb-8">
            {["How It Works", "Packages", "Gallery", "Contact"].map((link) => (
              <a
                key={link}
                href={`#${link.toLowerCase().replace(/\s/g, "-")}`}
                className="font-montserrat text-white/30 text-xs tracking-[0.2em] uppercase hover:text-[#D4AF37] transition-colors duration-300"
              >
                {link}
              </a>
            ))}
            <a
              href="/admin"
              data-testid="footer-admin-link"
              className="font-montserrat text-white/15 text-xs tracking-[0.2em] uppercase hover:text-[#D4AF37] transition-colors duration-300"
            >
              Admin
            </a>
          </div>

          {/* Copyright */}
          <p className="font-montserrat text-white/20 text-xs tracking-wider">
            &copy; {new Date().getFullYear()} Vicki Ann's Luxurious Gifts. All
            Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
